"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectsBenchmarkIndustry;
(function (ProjectsBenchmarkIndustry) {
    ProjectsBenchmarkIndustry["All"] = "all";
    ProjectsBenchmarkIndustry["MyIndustry"] = "mine";
})(ProjectsBenchmarkIndustry = exports.ProjectsBenchmarkIndustry || (exports.ProjectsBenchmarkIndustry = {}));
var ProjectsBenchmarkCountry;
(function (ProjectsBenchmarkCountry) {
    ProjectsBenchmarkCountry["FRANCE"] = "FR";
    ProjectsBenchmarkCountry["UNITED_STATES"] = "US";
    ProjectsBenchmarkCountry["UNITED_KINGDOM"] = "GB";
    ProjectsBenchmarkCountry["ITALY"] = "IT";
    ProjectsBenchmarkCountry["SPAIN"] = "ES";
    ProjectsBenchmarkCountry["GERMANY"] = "DE";
    ProjectsBenchmarkCountry["CHINA"] = "CN";
    ProjectsBenchmarkCountry["NETHERLANDS"] = "NL";
})(ProjectsBenchmarkCountry = exports.ProjectsBenchmarkCountry || (exports.ProjectsBenchmarkCountry = {}));
//# sourceMappingURL=index.js.map